import { render, staticRenderFns } from "./image-zoom.vue?vue&type=template&id=4eeed031&scoped=true"
import script from "./image-zoom.vue?vue&type=script&lang=js"
export * from "./image-zoom.vue?vue&type=script&lang=js"
import style0 from "./image-zoom.vue?vue&type=style&index=0&id=4eeed031&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeed031",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eeed031')) {
      api.createRecord('4eeed031', component.options)
    } else {
      api.reload('4eeed031', component.options)
    }
    module.hot.accept("./image-zoom.vue?vue&type=template&id=4eeed031&scoped=true", function () {
      api.rerender('4eeed031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/image-zoom.vue"
export default component.exports